import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { ReactNode, useEffect, useState } from 'react';
import LoginButton from './LoginButton';

interface AuthGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const AuthGuard = ({ children, fallback }: AuthGuardProps) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Give MSAL time to complete initialization and redirect handling
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading || inProgress === 'startup' || inProgress === 'handleRedirect') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      fallback || (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-lg shadow-md">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Authentication Required</h2>
              <p className="text-gray-600 mb-6">Please sign in to access this feature.</p>
              <LoginButton />
            </div>
          </div>
        </div>
      )
    );
  }

  return <>{children}</>;
};

export default AuthGuard;